import {HttpResponse} from '@angular/common/http';
import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {
    CompanyDto,
    ConfiguratorCompanyService,
    ConfiguratorContactService,
    ContactDTO,
    DatastoreDto,
    Partner
} from '@tj/tj-dmp-lib-api';
import {ConfirmationService, MenuItem, MessageService} from 'primeng/api';
import {map, switchMap} from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Component({
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss'],
    standalone: false
})
export class ContactComponent implements OnInit {

    breadcrumb: MenuItem[] = [
        { label: this.translate.instant('menu.invoice.label') },
        { label: this.translate.instant('menu.invoice.contacts') }
    ];
    description = this.translate.instant('invoicing.contacts.description');

    datastore: DatastoreDto;
    partner: Partner;

    contacts: ContactDTO[] = [];
    enhancedContacts:any=[]
    actual: ContactDTO = null;
    actualId = null;
    actualCompanyName: string = null;

    showDetails = false;

    state: { message: string };

    items = [
        {
            label: this.translate.instant('invoicing.common.view'),
            items: [{
                label: this.translate.instant('invoicing.common.more'),
                icon: 'fas fa-user',
                permission: "INVOICECONTACTS.read",
                command: () => {
                    this.showDetails = true;
                }
            }]
        },
        {
            label: this.translate.instant('invoicing.common.manage'),
            items: [
                {
                    label: this.translate.instant('invoicing.common.edit'),
                    icon: 'fas fa-pen',
                    permission: "INVOICECONTACTS.edit",
                    command: () => {
                        // TODO change by id
                        this.router.navigate([`/h/invoicing/contact/edit/${this.datastore.code}/${this.actual.id}`]);
                    }
                },
                {
                    label: this.translate.instant('invoicing.common.delete'),
                    icon: 'fas fa-trash',
                    permission: "INVOICECONTACTS.delete",
                    command: () => {
                        this.confirmationService.confirm({
                            message: this.translate.instant('invoicing.contacts.deleteConfirm', {firstName: this.actual.firstname, lastName: this.actual.name}),
                            accept: () => {
                                this.contactService.deleteContactUsingDELETE(this.datastore.code, this.actual.id).subscribe(() => {
                                    this.loadAll();
                                    this.messageService.add({
                                        severity: 'success',
                                        summary: this.translate.instant('invoicing.common.success'),
                                        detail: this.translate.instant('invoicing.contacts.deleted')
                                    });
                                }, (e) => {
                                    this.messageService.add({
                                        severity: 'error',
                                        summary: this.translate.instant('invoicing.common.error'),
                                        detail: this.translate.instant('invoicing.common.genericError', {error: e.toString()})
                                    });
                                });
                            }
                        });
                    }
                }]
        },
    ];

    constructor(
        protected contactService: ConfiguratorContactService,
        private companyService: ConfiguratorCompanyService,
        private confirmationService: ConfirmationService,
        private router: Router,
        private messageService: MessageService,
        private readonly translate: TranslateService
    ) {
        const navigation = this.router.getCurrentNavigation();
        this.state = (navigation?.extras?.state as { message: string }) ?? null;
    }

    ngOnInit(): void {
        if (this.state?.message === 'success_created') {
            setTimeout(() => this.messageService.add({ severity: 'success', summary: this.translate.instant('invoicing.common.success'), detail: this.translate.instant('invoicing.contacts.created') }));
        } else if (this.state?.message === 'success_updated') {
            setTimeout(() => this.messageService.add({ severity: 'success', summary: this.translate.instant('invoicing.common.success'), detail: this.translate.instant('invoicing.contacts.updated') }));
        }
    }

    datastoreChange(datastore: DatastoreDto) {
        this.datastore = datastore;
    }

    partnerChange(partner: Partner) {
        this.partner = partner;
    }

    loadAll() {
        if (this.datastore && this.partner) {
            this.contactService
                .getAllContactsUsingGET(this.datastore.code, this.partner.code, 'response')
                .pipe(
                    switchMap((res: HttpResponse<ContactDTO[]>) =>{
                        this.contacts = res.body;
                        return this.companyService.getAllCompaniesUsingGET(this.datastore.code);
                    }),
                    map((companies: CompanyDto[]) => {
                        return this.contacts.map(contact => {
                            const company = companies.find(c => c.id === contact.company);
                            return {
                                ...contact,
                                companyName: company ? company.name : null
                            };
                        });
                    })
                )
                .subscribe(
                    (enhancedContacts: any[]) => {
                        this.enhancedContacts = enhancedContacts;
                        console.log(this.enhancedContacts);
                    },
                    error => {
                        console.error('Erreur lors du chargement des contacts ou des entreprises', error);
                    }
                );
        } else {
            this.contacts = [];
            this.enhancedContacts = [];
        }
    }

    navigateToDetail(contact: any, i:number) {
        this.actual = contact;
        this.actualCompanyName = contact.companyName;
        this.actualId = i + 1
        this.actual = contact;
        this.showDetails = true;
    }
}
